<template>
    <div class="phone mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="post_phone != '' ? 'border-primary' : ''" type="tel" id="inputPhone"
                v-model="post_phone"
                @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': post_phone != ''
                }">Số điện thoại</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            post_phone: '',
        }
    },
    watch: {
        data(val){
            this.post_phone = this.$formatNumberPhome(val);
        },
        post_phone(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.post_phone = this.$formatNumberPhome(this.data);
    }
}
</script>
